import Render from '@Views/components/popin/layout/popin-change-invoice-status-rfe.html'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { InvoiceStatus } from '@Enums/index'

@Render
@Component({})
export class PopinChangeInvoiceStatusRfe extends Vue {

	@Prop() options: {statut: string, reason: string}
	@Prop({default: false}) submitted: boolean

	get isRefused(): boolean {
		return this.options.statut === InvoiceStatus.Refused
	}

	get isAccepted(): boolean {
		return this.options.statut === InvoiceStatus.Accepted
	}

	accept(): void {
		this.options.statut = InvoiceStatus.Accepted
		this.options.reason = ''
	}

	refuse(): void {
		this.options.statut = InvoiceStatus.Refused
	}
}
